import { Menu } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Logo } from '../common/Logo';

interface HeaderProps {
  onMenuClick: () => void;
  rightElement?: React.ReactNode;
}

export function Header({ onMenuClick, rightElement }: HeaderProps) {
  return (
    <header className="sticky top-0 z-40 bg-deep-blue/80 backdrop-blur-lg border-b border-white/5">
      <div className="flex items-center justify-between px-4 py-3">
        <button
          onClick={onMenuClick}
          className="p-2 -ml-2 text-white/70 hover:text-white hover:bg-white/10 rounded-lg transition-colors"
          aria-label="Abrir menu"
        >
          <Menu className="w-6 h-6" />
        </button>

        <Link to="/">
          <Logo size="sm" />
        </Link>

        <div className="w-10">
          {rightElement}
        </div>
      </div>
    </header>
  );
}

